import { Type } from 'class-transformer';
import { DimensionOptionResultDto } from '../../common/dimensions/dimension-option-result-dto';

export class ARAdjustmentItemResultDto {
    arAdjustmentItemId: number;
    glAccountNumberTitle: string;
    offsetGLAccountNumberTitle: string;
    accountLabelTitle: string;
    subCategory: string;
    amount: number;
    openBalance: number;
    description: string;

    @Type(() => DimensionOptionResultDto)
    dimensions: DimensionOptionResultDto[];

    // Transient variable
    writeOffAmount: number;
    isSelect = false;
}
